import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'usimweb-icon',
    template: `
    <mat-icon
      *ngIf="outlined"
      class="material-icons-outlined"
      [style.width]="sizePx"
      [style.height]="sizePx"
      [style.font-size]="sizePx"
      [matTooltip]="toolTip"
      (click)="onClick.emit($event)"
      matSuffix
    >
      {{ icon }}
    </mat-icon>
    <mat-icon
      *ngIf="!outlined"
      [style.width]="sizePx"
      [style.height]="sizePx"
      [style.font-size]="sizePx"
      [matTooltip]="toolTip"
      (click)="onClick.emit($event)"
      matSuffix
    >
      {{ icon }}
    </mat-icon>
  `,
    standalone: false
})
export class IconComponent implements OnInit {
  @Input() toolTip!: string;
  @Input() icon!: string;
  @Input() outlined: boolean = false;
  @Input() size!: number;

  @Output() onClick = new EventEmitter<any>();

  public sizePx!: string;

  ngOnInit(): void {
    this.sizePx = this.size + 'px';
  }
}
